import { render, staticRenderFns } from "./bonusv2.vue?vue&type=template&id=07a48372&scoped=true"
import script from "./bonusv2.vue?vue&type=script&lang=js"
export * from "./bonusv2.vue?vue&type=script&lang=js"
import style0 from "./bonusv2.vue?vue&type=style&index=0&id=07a48372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a48372",
  null
  
)

export default component.exports